const positive = value => Number(value) > 0;

const hasBreakfastBooking = employeeOrder => (
  [
    'total_halves',
    'white_halves',
    'seeded_halves',
    'boiled_eggs',
    'fried_eggs',
    'scrambled_eggs',
  ].some(field => positive(employeeOrder?.[field]))
  || Boolean(employeeOrder?.has_coffee)
  || Boolean(String(employeeOrder?.notes || '').trim())
);

export const buildMealHistorySummary = employeeOrders => {
  const orders = Object.values(employeeOrders || {}).filter(Boolean);
  const breakfastCount = orders.filter(hasBreakfastBooking).length;
  const lunchCount = orders.reduce(
    (sum, order) => sum + (order.has_lunch ? Math.max(1, Number(order.lunch_count) || 1) : 0),
    0,
  );
  const dinnerCount = orders.reduce(
    (sum, order) => sum + (order.has_dinner ? Math.max(1, Number(order.dinner_count) || 1) : 0),
    0,
  );

  return [
    breakfastCount > 0 ? `${breakfastCount} × Frühstück` : null,
    lunchCount > 0 ? `${lunchCount} × Mittag` : null,
    dinnerCount > 0 ? `${dinnerCount} × Abend` : null,
  ].filter(Boolean);
};
